(() => {
 if(window.akumaProductOverflowLoaded)return;
 window.akumaProductOverflowLoaded=true;
 const desktop=matchMedia('(min-width:990px)');
 const galleries=new Map();
 function setup(gallery){
  if(galleries.has(gallery))return;
  const list=gallery.querySelector('.product__media-list');
  if(!list)return;
  const extra=document.createElement('ul');
  extra.className='product__media-list akuma-product-overflow list-unstyled';
  extra.setAttribute('aria-label',gallery.getAttribute('aria-label')||'Product images');
  extra.tabIndex=0;
  list.after(extra);
  let frame;
  const observer=new MutationObserver(()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(layout);});
  const watch=()=>observer.observe(list,{childList:true});
  function restore(){
   observer.disconnect();
   while(extra.firstElementChild)list.append(extra.firstElementChild);
   extra.hidden=true;
  }
  function layout(){
   restore();
   if(desktop.matches){
    [...list.children].slice(6).forEach(item=>extra.append(item));
    extra.hidden=!extra.children.length;
   }
   list.closest('slider-component')?.resetPages?.();
   watch();
  }
  gallery.akumaRestoreMedia=restore;
  gallery.akumaLayoutMedia=layout;
  const onKey=event=>{if(!['ArrowLeft','ArrowRight'].includes(event.key))return;event.preventDefault();extra.scrollBy({left:(event.key==='ArrowRight'?1:-1)*extra.clientWidth/3,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
  extra.addEventListener('keydown',onKey);
  galleries.set(gallery,{layout,cleanup:()=>{observer.disconnect();cancelAnimationFrame(frame);delete gallery.akumaRestoreMedia;delete gallery.akumaLayoutMedia;}});
  layout();
 }
 const refresh=()=>{
  for(const [gallery,state] of galleries)if(!gallery.isConnected){state.cleanup();galleries.delete(gallery);}
  document.querySelectorAll('.akuma-editorial-product media-gallery').forEach(setup);
 };
 desktop.addEventListener('change',()=>galleries.forEach(state=>state.layout()));
 document.addEventListener('shopify:section:load',refresh);document.addEventListener('shopify:section:unload',refresh);
 refresh();
})();
